import { render, staticRenderFns } from "./NodeServiceDetail.vue?vue&type=template&id=3effbf8b&scoped=true"
var script = {}
import style0 from "./NodeServiceDetail.vue?vue&type=style&index=0&id=3effbf8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3effbf8b",
  null
  
)

export default component.exports